export * from './currency.client';
import { CurrencyClient } from './currency.client';
export * from './master-wallet.client';
import { MasterWalletClient } from './master-wallet.client';
export * from './mining-product.client';
import { MiningProductClient } from './mining-product.client';
export * from './observer-link.client';
import { ObserverLinkClient } from './observer-link.client';
export * from './pool-commission.client';
import { PoolCommissionClient } from './pool-commission.client';
export * from './portal-global-notification.client';
import { PortalGlobalNotificationClient } from './portal-global-notification.client';
export * from './referral.client';
import { ReferralClient } from './referral.client';
export * from './transaction-type.client';
import { TransactionTypeClient } from './transaction-type.client';
export * from './user.client';
import { UserClient } from './user.client';
export * from './user-dictionary.client';
import { UserDictionaryClient } from './user-dictionary.client';
export * from './withdrawal-limits.client';
import { WithdrawalLimitsClient } from './withdrawal-limits.client';
export * from './withdrawal-requests.client';
import { WithdrawalRequestsClient } from './withdrawal-requests.client';
export const APIS = [CurrencyClient, MasterWalletClient, MiningProductClient, ObserverLinkClient, PoolCommissionClient, PortalGlobalNotificationClient, ReferralClient, TransactionTypeClient, UserClient, UserDictionaryClient, WithdrawalLimitsClient, WithdrawalRequestsClient];
